import React__default, { useRef } from "react";
import { useDisposables as p } from "../../hooks/use-disposables.js";
import { useEvent as o } from "../../hooks/use-event.js";
import { useEventListener as E } from "../../hooks/use-event-listener.js";
import { useIsMounted as f } from "../../hooks/use-is-mounted.js";
import { useIsTopLayer as x$1 } from "../../hooks/use-is-top-layer.js";
import { useOnUnmount as c } from "../../hooks/use-on-unmount.js";
import { useOwnerDocument as n } from "../../hooks/use-owner.js";
import { useServerHandoffComplete as l } from "../../hooks/use-server-handoff-complete.js";
import { useSyncRefs as y } from "../../hooks/use-sync-refs.js";
import { useTabDirection as u, Direction as a } from "../../hooks/use-tab-direction.js";
import { useWatch as m } from "../../hooks/use-watch.js";
import { Hidden as T, HiddenFeatures as s } from "../../internal/hidden.js";
import { history as r } from "../../utils/active-element-history.js";
import { focusIn as P, Focus as F, focusElement as I$1, FocusResult as T$1 } from "../../utils/focus-management.js";
import { match as u$1 } from "../../utils/match.js";
import { microTask as t } from "../../utils/micro-task.js";
import { forwardRefWithAs as W, render as H } from "../../utils/render.js";
function U(o2) {
  if (!o2) return /* @__PURE__ */ new Set();
  if (typeof o2 == "function") return new Set(o2());
  let e = /* @__PURE__ */ new Set();
  for (let t2 of o2.current) t2.current instanceof HTMLElement && e.add(t2.current);
  return e;
}
let Y = "div";
var x = ((n2) => (n2[n2.None = 0] = "None", n2[n2.InitialFocus = 1] = "InitialFocus", n2[n2.TabLock = 2] = "TabLock", n2[n2.FocusLock = 4] = "FocusLock", n2[n2.RestoreFocus = 8] = "RestoreFocus", n2[n2.AutoFocus = 16] = "AutoFocus", n2))(x || {});
function Z(o$1, e) {
  let t2 = useRef(null), r2 = y(t2, e), { initialFocus: s$1, initialFocusFallback: a$1, containers: n$1, features: u$2 = 15, ...f2 } = o$1;
  l() || (u$2 = 0);
  let l$1 = n(t2);
  w(u$2, { ownerDocument: l$1 });
  let i = ee(u$2, { ownerDocument: l$1, container: t2, initialFocus: s$1, initialFocusFallback: a$1 });
  te(u$2, { ownerDocument: l$1, container: t2, containers: n$1, previousActiveElement: i });
  let R = u(), g = o((c2) => {
    let m2 = t2.current;
    if (!m2) return;
    ((B) => B())(() => {
      u$1(R.current, { [a.Forwards]: () => {
        P(m2, F.First, { skipElements: [c2.relatedTarget, a$1] });
      }, [a.Backwards]: () => {
        P(m2, F.Last, { skipElements: [c2.relatedTarget, a$1] });
      } });
    });
  }), v = x$1(!!(u$2 & 2), "focus-trap#tab-lock"), N = p(), F$1 = useRef(false), k = { ref: r2, onKeyDown(c2) {
    c2.key == "Tab" && (F$1.current = true, N.requestAnimationFrame(() => {
      F$1.current = false;
    }));
  }, onBlur(c2) {
    if (!(u$2 & 4)) return;
    let m2 = U(n$1);
    t2.current instanceof HTMLElement && m2.add(t2.current);
    let d = c2.relatedTarget;
    d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && (I(m2, d) || (F$1.current ? P(t2.current, u$1(R.current, { [a.Forwards]: () => F.Next, [a.Backwards]: () => F.Previous }) | F.WrapAround, { relativeTo: c2.target }) : c2.target instanceof HTMLElement && I$1(c2.target)));
  } };
  return React__default.createElement(React__default.Fragment, null, v && React__default.createElement(T, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: g, features: s.Focusable }), H({ ourProps: k, theirProps: f2, defaultTag: Y, name: "FocusTrap" }), v && React__default.createElement(T, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: g, features: s.Focusable }));
}
let $ = W(Z), Fe = Object.assign($, { features: x });
function D(o$1 = true) {
  let e = useRef(r.slice());
  return m(([t$1], [r$1]) => {
    r$1 === true && t$1 === false && t(() => {
      e.current.splice(0);
    }), r$1 === false && t$1 === true && (e.current = r.slice());
  }, [o$1, r, e]), o(() => {
    var t2;
    return (t2 = e.current.find((r2) => r2 != null && r2.isConnected)) != null ? t2 : null;
  });
}
function w(o2, { ownerDocument: e }) {
  let t2 = !!(o2 & 8), r2 = D(t2);
  m(() => {
    t2 || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && I$1(r2());
  }, [t2]), c(() => {
    t2 && I$1(r2());
  });
}
function ee(o2, { ownerDocument: e, container: t$1, initialFocus: r2, initialFocusFallback: s2 }) {
  let a2 = useRef(null), n2 = x$1(!!(o2 & 1), "focus-trap#initial-focus"), u2 = f();
  return m(() => {
    if (o2 === 0) return;
    if (!n2) {
      s2 != null && s2.current && I$1(s2.current);
      return;
    }
    let f2 = t$1.current;
    f2 && t(() => {
      if (!u2.current) return;
      let l2 = e == null ? void 0 : e.activeElement;
      if (r2 != null && r2.current) {
        if ((r2 == null ? void 0 : r2.current) === l2) {
          a2.current = l2;
          return;
        }
      } else if (f2.contains(l2)) {
        a2.current = l2;
        return;
      }
      if (r2 != null && r2.current) I$1(r2.current);
      else {
        if (o2 & 16) {
          if (P(f2, F.First | F.AutoFocus) !== T$1.Error) return;
        } else if (P(f2, F.First) !== T$1.Error) return;
        if (s2 != null && s2.current && (I$1(s2.current), (e == null ? void 0 : e.activeElement) === s2.current)) return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      a2.current = e == null ? void 0 : e.activeElement;
    });
  }, [s2, n2, o2]), a2;
}
function te(o2, { ownerDocument: e, container: t2, containers: r2, previousActiveElement: s2 }) {
  let a2 = f(), n2 = !!(o2 & 4);
  E(e == null ? void 0 : e.defaultView, "focus", (u2) => {
    if (!n2 || !a2.current) return;
    let f2 = U(r2);
    t2.current instanceof HTMLElement && f2.add(t2.current);
    let l2 = s2.current;
    if (!l2) return;
    let i = u2.target;
    i && i instanceof HTMLElement ? I(f2, i) ? (s2.current = i, I$1(i)) : (u2.preventDefault(), u2.stopPropagation(), I$1(l2)) : I$1(s2.current);
  }, true);
}
function I(o2, e) {
  for (let t2 of o2) if (t2.contains(e)) return true;
  return false;
}
export {
  Fe as FocusTrap,
  x as FocusTrapFeatures
};
